import { disablePageScroll, enablePageScroll } from "scroll-lock";

function scrollCardPopup() {
  let menu = $('.cart-popup');
  menu.on('mouseenter', function() {
    disablePageScroll();
  });
  menu.on('mouseleave', function() {
    enablePageScroll();
  });
}
scrollCardPopup();